import React from "react";
import Filter from "../listing/filter";

const FilterPopup = ({ handleClose }) => {
  return (
    <div className='filter-popup-content'>
      <div className='filter-popup-content-top'>
        <h4>Filters</h4>
        <span onClick={handleClose}>X</span>
      </div>
      <div className='filter-popup-content-scroll'>
        <Filter />
      </div>
    </div>
  );
};

export default FilterPopup;
